
























































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator';
import {Getter, State} from 'vuex-class';
import User from '@/modules/user/model/User';
import {RejectionReason} from '@/modules/reservation/model/CreateListResult';
import {DeleteUserRejection, DeleteUserRejectionReason, UserAssociation} from '@/modules/user/api';
import {Colors, notify} from '@/modules/core/notification';
import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Confirmación de eliminación de usuario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ConfirmDeleteUser extends Vue {
    @State(state => state.user.currentUser)
    public user: User

    /**
    * Comprueba si el módulo argumentado se encuentra activo en la aplicación
    */
    @Getter('moduleIsEnabled')
    public moduleIsEnabled: (module: string) => boolean

    /**
     * Controla la visibilidad del dialogo
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    @State(state => state.user.checkingiDeleteFromBBDDUnigest)
    public checkingiDeleteFromBBDDUnigest: boolean

    public deleting = false

    public userAssociationsDialog = false

    public rejectionReason = ''
    public associations: UserAssociation[] = []

    public assocTypeIcons: KeyValuePair = {
        reservations: 'mdi-soccer-field',
        posts: 'mdi-post-outline',
        static_pages: 'mdi-sitemap',
        media_objects: 'mdi-image-outline',
    }

    /**
     * Solicita a la aplicación la eliminación del usuario actual
     */
    public async remove () {
        (async () => {
            this.deleting = true
            const { id, name } = this.user
            await this.$store.dispatch('user/beforeDeleteUser', {delay:100})
            await this.$store.dispatch('user/deleteUser')
            await this.$router.push({ name: 'user-list'})
            this.deleting = false
            notify(`El usuario ${name}(${id}) ha sido eliminado correctamente`)
        })();
    }

    public errorCaptured (error: DeleteUserRejection | Error) {
        this.deleting = false
        if ('reason' in error && error.reason === DeleteUserRejectionReason.UserHAsAssociations) {
            this.userAssociationsDialog = true
            this.rejectionReason = error.message
            this.associations = error.associations

            return
        }

        notify(error.message, Colors.Error)
    }

    public oncheckingiDeleteFromBBDDUnigest(event: boolean) {
        event = event || false;
        this.$store.commit('user/TOGGLE_USER_GROUP_DELETE_PLAFORM_UNIGEST', event)
    }
}
